import {ModuleWithProviders, NgModule} from "@angular/core";
import {NControlsModule} from "n-framework/n-controls";
// BUG: do not fix path, see https://github.com/dherges/ng-packagr/issues/734
import {NPromptModalComponent} from "./components/n-prompt-modal/n-prompt-modal.component";
import {CommonModule} from "@angular/common";
import {ReactiveFormsModule} from "@angular/forms";
import {PromptModalService} from "./PromptModalService";
import {NModalModule} from "n-framework/n-modal";


const PUBLIC_COMPONENTS = [
  NPromptModalComponent
];

@NgModule({
  declarations: [
    ...PUBLIC_COMPONENTS
  ], // directives, components, and pipes owned by this NgModule
  imports: [
    NModalModule,
    NControlsModule,
    ReactiveFormsModule,
    CommonModule
  ],
  exports: [
    ...PUBLIC_COMPONENTS
  ],
  providers: [],
  entryComponents: [
    NPromptModalComponent
  ]
})

export class NPromptModule {
  static forRoot(): ModuleWithProviders<NPromptModule> {
    return {
      ngModule: NPromptModule,
      providers: [
        PromptModalService
      ]
    };
  }
}
